import { useIsPacingActive } from "@expert/sales-tools";
import { SimpleGrid } from "@mantine/core";

import { LivePaceCard } from "./LivePaceCard";
import { LiveSalesCard } from "./LiveSalesCard";
import { LiveTotalCallsCard } from "./LiveTotalCallsCard";

export function LiveMetrics() {
    const isPacingActive = useIsPacingActive();

    return (
        <SimpleGrid
            type="container"
            cols={isPacingActive ? { base: 1, "440px": 2, "680px": 3 } : { base: 1, "440px": 2 }}
            spacing="md"
        >
            <LiveTotalCallsCard />
            {isPacingActive && <LivePaceCard />}
            <LiveSalesCard />
        </SimpleGrid>
    );
}
